import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';

import FormattedCurrency from '../FormattedCurrency';
import EditableToggle from './EditableToggle';

const limitValue = (value, min, max) => {
  let result = Number.parseFloat(value);
  if (typeof result !== 'number') return null;
  if (typeof min !== 'undefined' && min !== null) result = Math.max(min, result);
  if (typeof max !== 'undefined' && max !== null) result = Math.min(max, result);
  return result;
};

const EditableCurrency = ({
  onChange,
  value,
  submitOnBlur,
  inputClassName,
  readOnly,
  placeholder,
  minimumFractionDigits,
  maximumFractionDigits,
  min,
  max,
  ...rest
}) => (
  <EditableToggle
    onSubmit={onChange}
    value={value}
    readOnly={readOnly}
    displayValue={
      !value && value !== 0 ? null : (
        <FormattedCurrency
          value={value}
          minimumFractionDigits={minimumFractionDigits}
          maximumFractionDigits={maximumFractionDigits}
        />
      )
    }
  >
    {({ inputValue, setInputValue, inputRef, submit, cancel, handleKeyDown }) => (
      <input
        type="number"
        value={inputValue}
        onChange={e => setInputValue(limitValue(e.target.value, min, max))}
        ref={inputRef}
        onBlur={submitOnBlur ? submit : cancel}
        onKeyDown={handleKeyDown}
        className={classnames('form-control', inputClassName)}
        onFocus={event => event.target.select()}
        placeholder={placeholder}
        autoComplete="off"
        style={{ textAlign: 'right' }}
        step="any"
        {...rest}
      />
    )}
  </EditableToggle>
);

EditableCurrency.propTypes = {
  onChange: PropTypes.func.isRequired,
  value: PropTypes.number,
  submitOnBlur: PropTypes.bool,
  placeholder: PropTypes.string,
  inputClassName: PropTypes.string,
  readOnly: PropTypes.bool,
  minimumFractionDigits: PropTypes.number,
  maximumFractionDigits: PropTypes.number,
  min: PropTypes.number,
  max: PropTypes.number,
};
EditableCurrency.defaultProps = {
  value: null,
  submitOnBlur: true,
  inputClassName: '',
  placeholder: '',
  readOnly: false,
  minimumFractionDigits: 2,
  maximumFractionDigits: 2,
  min: undefined,
  max: undefined,
};

export default EditableCurrency;
